import dateRangePickerComponentUrl from './dateRangePickerComponent.html';
class DateRangePickerCtrl {
  constructor(Utils) {
    'ngInject';

    Object.assign(this, { Utils });
    this._initialized = true; // This is a guard for some weird behavior in unit tests
  }

  $onInit() {
    const instance = this;
    this._endDatepickerOptions = {
      get minDate() {
        return instance.endMinDate;
      },
    };

    this.addon = {
      action: () => {
        this.isOpen = false;
        this.end = new Date(this.endTemp);
        this.start = new Date(this.startTemp);
      },
      cancel: () => {
        this.isOpen = false;
      },
      template: `
        <div class="row margin-top-20 date-range-custom-selector-actions">
          <div class="col-xs-8">
            <button type="button" class="btn btn-cancel btn-lg btn-block" ng-click="datepickerAddon.cancel()">
              Cancel
            </button>
          </div>
          <div class="col-xs-8">
            <button type="button" class="btn btn-primary btn-lg btn-block" ng-click="datepickerAddon.action()">
              Apply
            </button>
          </div>
        </div>
      `,
    };
  }

  get endDatepickerOptions() {
    return this._endDatepickerOptions;
  }

  get isOpen() {
    return this._isOpen;
  }

  set isOpen(val) {
    this._isOpen = val;
    if (val) {
      this.endTemp = new Date(this.end);
      this.startTemp = new Date(this.start);
    }
  }

  get start() {
    return this._start;
  }

  set start(val) {
    this._start = val;
    this.startTemp = val;
  }

  get end() {
    return this._end;
  }

  set end(val) {
    this._end = val;
    this.endTemp = val;
  }

  get startTemp() {
    return this._startTemp;
  }

  set startTemp(val) {
    this._startTemp = val;

    if (this._initialized) {
      this.endMinDate = new Date(val);
      if (this.endTemp < this.endMinDate) {
        this.endTemp = new Date(this.endMinDate);
      }
    }
  }
}

export default {
  bindings: {
    isOpen: '=',
    start: '=rangeStart',
    end: '=rangeEnd',
  },
  controllerAs: 'ctrl',
  controller: DateRangePickerCtrl,
  templateUrl: dateRangePickerComponentUrl,
};
